import React from 'react';
import PropTypes from 'prop-types';
import ClipboardJS from 'clipboard';
import I18n from '../i18n';
import NotificationContext from '../../contexts/notification-context';

const copySupported = document.queryCommandSupported && document.queryCommandSupported('copy');

export default function CopyToClipboard(props) {
  const {target, text, children} = props;
  const thisNode = React.useRef();
  const notificationContext = React.useContext(NotificationContext);

  const onSuccess = React.useCallback(() => {
    notificationContext.showSuccessNotification(I18n.t('notification.copy-to-clipboard-success'));
  }, []);

  const onError = React.useCallback(copyEvent => {
    console.error('Failed to copy text to clipboard', copyEvent);
    notificationContext.showDangerNotification(I18n.t('notification.copy-to-clipboard-failed'));
  }, []);

  React.useEffect(() => {
    const clipboardInstance = new ClipboardJS(thisNode.current);

    clipboardInstance.on('success', onSuccess);
    clipboardInstance.on('error', onError);

    return () => {
      clipboardInstance.off('success');
      clipboardInstance.off('error');
    };
  }, [thisNode.current]);

  return (
    <span
      ref={thisNode}
      data-clipboard-target={target}
      data-clipboard-text={text}
      style={copySupported ? {} : {display: 'none'}}
    >
      {children}
    </span>
  );
}

CopyToClipboard.defaultProps = {};

CopyToClipboard.propTypes = {
  /** A button or element to use as the copy button. */
  children: PropTypes.node.isRequired,
  /** CSS selector used to find the target element to get the text from. . Use this or `text` */
  target: PropTypes.string,
  /** The text to place on the clipboard. Use this or `target` */
  text: PropTypes.string,
};
